import { eyebrowClassName } from '@ideon-api/ideon-ui'
import type { ReactNode } from 'react'

interface PanelProps {
  title: string
  subtitle?: string
  children: ReactNode
}

// Flush card: ideon-ui's Section pads its whole surface, which would inset the banded headers.
export function Panel({ title, subtitle, children }: PanelProps) {
  return (
    <section className="overflow-hidden rounded-lg border border-ideon-gray-40 bg-white">
      <div className="flex items-center gap-3 px-4 py-4">
        <div className="min-w-0">
          <h2 className="font-manrope text-lg font-semibold leading-6 text-ideon-gray-black">{title}</h2>
          {/* Height held when empty so the card does not shift as data lands. */}
          <p className="min-h-5 text-sm text-ideon-gray-70">{subtitle}</p>
        </div>
      </div>
      {children}
    </section>
  )
}

// Gray banded group header: uppercase label, muted count, optional trailing control.
export function BandHeader({ label, count, children }: { label: string; count: string; children?: ReactNode }) {
  return (
    <div className="flex min-h-11 items-center gap-3 border-y border-ideon-gray-40 bg-ideon-gray-20 px-4 py-2">
      <span className={`${eyebrowClassName} text-ideon-gray-black`}>{label}</span>
      <span className="text-[13px] text-ideon-gray-70">{count}</span>
      {children && <div className="ml-auto">{children}</div>}
    </div>
  )
}
